export default "__VITE_ASSET__BfKwHHZ2__"